/**
 * Styles
 */
import './common.scss';

/**
 * Blocks
 */
import './blocks/latest-testimonials-carousel/index.js';
